import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

export default function SourceInfoBox({
  children,
  title,
  header,
  logo,
  buttonText,
  buttonLink,
  onClick,
  dynamicHeight,
  loading,
  sx = {},
  id,
  buttonId,
}) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        height: dynamicHeight ? "100%" : undefined,
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        ...sx,
      }}
    >
      <Box id={id}>
        <Stack
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{
            xs: "start",
            md: "center",
          }}
        >
          <Typography variant="h6" color="primary.dark">
            {title}
          </Typography>
          {header}
        </Stack>
        <Divider sx={{ mt: 3, mb: 3 }} />
        {children}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
          mt: 3,
          "& > *:only-child": {
            marginLeft: "auto",
          },
        }}
      >
        {(buttonLink || onClick) && buttonText && (
          <Button
            id={buttonId}
            LinkComponent={Link}
            to={buttonLink}
            target="_blank"
            variant="chip"
            onClick={onClick}
            loading={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              buttonText
            )}
          </Button>
        )}
        {logo}
      </Box>
    </Paper>
  );
}
